import { Card, Col, Row } from "antd";
import { ResponsiveContainer, LineChart, Line } from "recharts";
import { useFormatNumber } from "hooks/useFormatNumber";
import { useMemo } from "react";
import { isEmpty, sum } from "lodash";
import { getDimensionColorByIndex } from "utils/colorUtils";

const CategoryScorecard = ({ data, dataKey, title, total, colorIndex = 0 }) => {
  const formatNumber = useFormatNumber();

  const categoryTotal = useMemo(() => {
    if (isEmpty(data)) return 0;
    return sum(data.map((item) => item[dataKey] || 0));
  }, [data, dataKey]);

  const percentage = useMemo(() => {
    if (!total) return 0;
    return (categoryTotal / total) * 100;
  }, [categoryTotal, total]);
  const absolute = formatNumber(categoryTotal);
  const percent = percentage.toFixed(1);

  const color = useMemo(() => {
    return getDimensionColorByIndex(colorIndex);
  }, [colorIndex]);

  const computedLine = useMemo(() => {
    if (isEmpty(data)) return null;
    return {
      name: title,
      dataKey,
      fill: color,
    };
  }, [data, dataKey, title, color]);

  const hasChart = !isEmpty(data) && computedLine;

  return (
    <Col span={12} xs={24} md={12} className="mb-8">
      <Card size="small" className="lg:h-full">
        {/* row 1: label only */}
        <Row>
          <Col span={24}>
            <div
              style={{
                fontSize: "14px",
                fontWeight: 400,
                color: color,
              }}
            >
              {title}
            </div>
          </Col>
        </Row>
        {/* row 2: number/percentage (col 1) + chart (col 2) */}
        <Row gutter={16} align="middle">
          <Col xs={12}>
            <div
              style={{ fontSize: "24px", fontWeight: 600, lineHeight: "32px" }}
            >
              {absolute}
            </div>
            <div
              style={{
                fontSize: "1.25em",
                color: "#8c8c8c",
                lineHeight: "1.2",
              }}
            >
              ({percent}%)
            </div>
          </Col>
          {hasChart && (
            <Col xs={12} className="flex items-end">
              <ResponsiveContainer width="100%" height={80}>
                <LineChart
                  data={data}
                  margin={{
                    top: 0,
                    right: 16,
                    left: 0,
                    bottom: 0,
                  }}
                >
                  <Line
                    dot={false}
                    name={computedLine.name}
                    type="monotone"
                    dataKey={computedLine.dataKey}
                    stroke={computedLine.fill}
                    strokeWidth={2}
                  />
                </LineChart>
              </ResponsiveContainer>
            </Col>
          )}
        </Row>
      </Card>
    </Col>
  );
};

export default CategoryScorecard;
